import styled from 'styled-components';
import { Text, Spacer } from '@zillow/constellation';

export const StyledRadioTitle = styled(Text)`
    width: 500px;
`;

export const StyledRadioContainer = styled(Spacer)`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
